<template>
  <main>
    <h1><u>Panneau d'administration de <i>FC ROBI</i></u></h1>
    <section>
      <h2>Bienvenu(e) sur <span>FC ROBI</span> !</h2>
      <p>Voici quelques liens pour vous aider à démarrer :</p>
      <nav class="d-flex flex-row flex-wrap justify-content-between">
        <article class="mt-3" :key="menu.id" v-for="(menu) in getMenu.filter( (m) => m.sousMenu.exists === false)">
          <router-link :to="menu.path" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="menu.icon"></font-awesome-icon>
            </div>
          </router-link>
          <router-link :to="menu.path" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>{{ menu.titre.charAt(0).toUpperCase() + menu.titre.slice(1) }}</div>
            <div>100</div>
          </router-link>
        </article>
<!--
        <article class="mt-3">
          <section>
            <div v-if="!menus.menuOpen4">
              <font-awesome-icon size="4x" :icon="['fas', 'people-carry']"></font-awesome-icon>
              <font-awesome-icon size="4x" :icon="['fas', 'people-carry']"></font-awesome-icon>
            </div>
            <div v-if="menus.menuOpen4">
              <div>
                <font-awesome-icon :icon="['fas', 'truck-loading']"></font-awesome-icon>
                <router-link to="livreurs">Livreurs</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'person-booth']"></font-awesome-icon>
                <router-link to="receptionnistes">Réceptionnistes</router-link>
              </div>
            </div>
          </section>
          <section @click="menus.menuOpen4 = !menus.menuOpen4" class="d-flex flex-row justify-content-between">
            <div>
              <font-awesome-icon v-if="!menus.menuOpen4" :icon="['fas', 'bars']"></font-awesome-icon>
              <font-awesome-icon v-if="menus.menuOpen4" :icon="['fas', 'times']"></font-awesome-icon>
            </div>
            <div>Agents</div>
            <div>20</div>
          </section>
        </article>
-->
      </nav>
    </section>
  </main>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: "Accueil",
  data () {
    return {
      menus : {
        menuOpen1: false,
        menuOpen2: false,
        menuOpen3: false,
        menuOpen4: false,
      }
    }
  },
  components: {},
  methods: {},
  computed: {
    ...mapGetters([
      'getMenu',
      'getMessageAdminConnexion',
    ])
  }
}
</script>

<style lang="scss" scoped>
main{
  margin-bottom: 1rem;
  & > h1{
    font-size: x-large;
    color: var(--color-golden-orange, rgba(204, 204, 0, 1));
  }
  & > section{
    border: 1px solid var(--color-light-gray, rgba(229, 222, 222, 1));
    padding: .5rem 1rem;
    & > h2{
      font-size: larger;
      color: var(--color-golden-orange, rgba(204, 204, 0, 1));
    }
    & > p{
      margin-bottom: 0;
      color: var(--color-white, rgba(255, 255, 255, 1));
    }
    & > nav{
      & > article{
        background: radial-gradient(circle, var(--color-light-golden-orange, rgba(204, 204, 0, .5)), var(--color-golden-orange, rgba(204, 204, 0, 1)));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-radius: 1rem;
        width: 235px;
        & > section:nth-child(1), & > section:nth-child(2){
          border: 1px solid var(--color-light-dark-gray, rgba(51, 51, 51, .5));
        }
        & > section:nth-child(1){
          text-align: center;
          padding: 1.5rem;
          border-radius: 1rem;
          height: 125px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          & > div{
            align-self: center;
            text-align: justify;
            font-size: .95rem;
            & > div{
              & > a{
                color: var(--color-white, rgba(255, 255, 255, 1));
              }
            }
          }
        }
        & > section:nth-child(1):hover, & > section:nth-child(2):hover{
          background-color: var(--color-white, rgba(255, 255, 255, 1));
          color: var(--color-black, rgba(0, 0, 0, 1));
          cursor: pointer;
          & > div{
            & > div{
              & > a{
                color: var(--color-black, rgba(0, 0, 0, 1));
              }
            }
          }
          & > div:nth-child(1){}
          & > div:nth-child(2){}
          & > div:nth-child(3){
            border-radius: 50%;
            font-size: small;
            padding: .3rem;
            background-color: var(--color-black, rgba(0, 0, 0, 1));
            color: var(--color-white, rgba(255, 255, 255, 1));
          }
        }
        & > section:nth-child(2){
          padding: .5rem .8rem;
          border-top: 1px solid var(--color-white, rgba(255, 255, 255, 1));
          border-bottom-left-radius: 1rem;
          border-bottom-right-radius: 1rem;
          & > div:nth-child(1){
            font-size: 1.2rem;
          }
          & > div:nth-child(2){}
          & > div:nth-child(3){
            border-radius: 50%;
            font-size: small;
            padding: .3rem;
            background-color: var(--color-white, rgba(255, 255, 255, 1));
            color: var(--color-black, rgba(0, 0, 0, 1));
          }
        }
      }
    }
  }
}

@media (min-width: 576px) {}

@media (min-width: 768px) {}

@media (min-width: 992px) {}
</style>



// WEBPACK FOOTER //
// src/components/Accueil.vue